import React from "react";
import { withRouter } from "react-router";
import { withStyles } from "@material-ui/core/styles";
import { white } from "../styles/color";
class DealsManagement extends React.Component {
  constructor(props) {
    super(props);
    if (window.cordova) {
      this.image = `${window.cordova.file.applicationDirectory}www`;
    }
  }

  render() {
    return (
      <div
        style={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
          justifyContent: "space-evenly",
          alignItems: "center"
        }}
      >
        <img alt="" src={
          window.cordova
            ? `${this.image}/deal.png`
            : "/deal.png"
        }
          height="200px" width="200px" />
        <div style={{ fontSize: "25px", color: white }}>Deals Management</div>
      </div>
    );
  }
}
export default withStyles()(withRouter(DealsManagement));
